export function safeParseJson<ExpectedShape>(jsonString: string | null | undefined): ExpectedShape | null {
  if (typeof jsonString !== 'string') {
    return null
  }

  try {
    // 💡: Add optional Zod schema to validate the parsed JSON
    return JSON.parse(jsonString) as ExpectedShape
  } catch (error) {
    console.error('Failed to parse JSON string', { error, jsonString })
    return null
  }
}
